import React, { useEffect } from 'react'
import { useTranslation } from "react-i18next";
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { allService } from '../../services';
import $ from 'jquery';
import toast, { Toaster } from 'react-hot-toast';


export default function ForgotPassword() {
   // Declaration of project constant
const { t, i18n } = useTranslation();
const [lang, setLang] = useState("Fr")
const history = useHistory();
const [newUser, setNewUser] = useState({ password: '', confirmpassword: ''})
const [telephone, setTelephone] = useState({ phone: ''})
const [load, setLoad] = useState({loadFirst : false, loadSecond : false, loadThird : false});
const [error, setError] = useState({errFirst : '', errSecond : '', errThird : '', resendCodeErr: ''});
const [modalLoader, setModalLoader] = useState(false);
const [isDisable, setDisable] = useState({disableFirst : true, disableSecond : true, disableThird : true});


//Function to use to handle language choice
const changeLanguageHandler = (l) => {
  i18n.changeLanguage(l.toLowerCase());
  setLang(l)
}

 // function that navigate 
 const navigation = (nav) => {
  history.push({
      pathname: nav,
  });
};



function next() {

  $("#recover-first").hide();
  $("#recover-second").show();
  $("#recover-third").hide();
 

}
function back() {
  $("#recover-first").show();
  $("#recover-second").hide();
  $("#recover-third").hide();
  setLoad({...load, loadFirst : false});
}
function next1() {
  $("#recover-first").hide();
  $("#recover-second").hide();
  $("#recover-third").show();
}

//to send number
const sendDataNumber = (e) => {
  e.preventDefault();
  const dataToStore = {
    telephone: telephone.phone,
  }
  resetUser(dataToStore);
}

// function that collects the data  on Submit
async function resetUser(data) {
  setLoad({...load, loadFirst : true});
  setError({... error, errFirst : ""});
  return allService.registerOrLogin(data, 'auth/password/reset/init')
  .then((d) => {
    next()
  })
  .catch((e) => {
    setLoad({...load, loadFirst : false});
    setError({... error, errFirst : e === "User account not found"? t("Account_not_found") : t("Failed_to_connect_to_server") , class: "err" })
  });
};

//To send number and code
const sendDataNumberCode = (e) => {
  e.preventDefault();
  const dataToStore = {
    telephone: telephone.phone,
    code : telephone.code
    
  }
  resetUser1(dataToStore);
}

// function that collects the data  on Submit
async function resetUser1(data) {
  setLoad({...load, loadSecond : true});
  setError({... error, errSecond : ""});
  
  return allService.registerOrLogin(data, 'auth/password/code/verify')
  .then((d) => {
    setLoad({...load, loadSecond : false});
    next1()
  })
  .catch((e) => {
    setLoad({...load, loadSecond : false});
    setError({... error, errSecond : e === "The code entered is not valid"? t("Wrong_verification_code") : t("Failed_to_connect_to_server") , class: "err" })
  });
 
};

//To send number and code
const sendDataNumberCodePass = (e) => {
  e.preventDefault();
  const dataToStore = {
    telephone: telephone.phone,
    code : telephone.code,
    new_password: telephone.password
    
  }
  resetUser2(dataToStore);
}

// function that collects the data  on Submit
async function resetUser2(data) {
  setLoad({...load, loadThird : true});
  setError({... error, errThird : ""});
  
  return allService.registerOrLogin(data, 'auth/password/update')
  .then((d) => {
    setLoad({...load, loadThird : false});
    toast.success("password successfuly changed", {
      style: {
        padding: '16px',
        color: '#fff',
        background: '#02274a',
        borderRadius: '10px',
      },
      iconTheme: {
        primary: '#229954',
        secondary: '#FFFAEE',
      },
    });
    
    navigation("/login")
  })
  .catch((e) => {
    setError({... error, errThird : e === "The code entered is not valid"? t("Wrong_verification_code") : t("Failed_to_connect_to_server") , class: "err" })
  });
 
};

const saveData2 = () => {
  const dataToStore = {
      telephone: telephone.phone,
  }
  createUser2(dataToStore);
}

async function createUser2(data) {
  setModalLoader(true);
  setError({ ...error, errSecond: '' });
  return allService.registerOrLogin(data, 'auth/password/code/resend')
      .then((d) => {
        setModalLoader(false);
        toast.success(t("resent_code"), {
          style: {
            padding: '16px',
            color: '#fff',
            background: '#02274a',
            borderRadius: '10px',
          },
          iconTheme: {
            primary: '#229954',
            secondary: '#FFFAEE',
          },
        });
      })
      .catch((e) => {
        setModalLoader(false);
        setError({ ...error, errSecond: t("Failed_to_connect_to_server") });
      });
}

const handleFormChange = (e) => {
  setTelephone({ ...telephone, [e.target.name]: e.target.value });
  setNewUser({ ...newUser, [e.target.name]: e.target.value });

  if (e.target.name === "phone" && e.target.value){
    setError({ ...error, phoneErr: !allService.validateOrangePhone(e.target.value) && !allService.validateMtnPhone(e.target.value) && !allService.validateCamtelBlue(e.target.value) && !allService.validateCamtelPhone(e.target.value) && !allService.validateNextelPhone(e.target.value)? t("Enter_a_valid_num") : '', errFirst : ""});
  }else if(e.target.name === "phone" && !e.target.value){
    setError({ ...error, phoneErr : "", errFirst : ""});
  }

  if(e.target.name === "password" && e.target.value){
    setError({ ...error, passwordErr : e.target.value.length < 4 ? t("Requires_atleast_04_Characters") : ""})
  }else if(e.target.name === "password" && !e.target.value){
    setError({ ...error, passwordErr : ""});
  }

  if(e.target.name === "confirmpassword" && e.target.value){
    setError({ ...error, confirmpasswordErr : e.target.value !== newUser.password ? t("Passwords_donot_correspond") : ""})
  }else if(e.target.name === "confirmpassword" && !e.target.value){
    setError({ ...error, confirmpasswordErr : ""});
  }
  if(e.target.name === "code" && e.target.value){
    setError({ ...error, codeErr : e.target.value.length != 4 ? t("code must be 4 digits") : "", errSecond : ""})
  }
}



const verifyFormState = () => {
  let answerFirst = true, answerSecond = true, answerThird = true;
  if (error.phoneErr === '') {
    answerFirst = false
  }
  if(error.codeErr === ''){
    answerSecond = false;
  }
  if(error.confirmpasswordErr === ''){
    answerThird = false;
  }

  setDisable({disableFirst : answerFirst, disableSecond : answerSecond, disableThird : answerThird})
}


useEffect(() => {
  verifyFormState()
}, [error]);

  return (
    <div className="row no-gutters h-100 w-100" style={{ position: 'absolute' }}>
      <div className="col col-6 d-none d-md-block p-0 h-100 text-center" style={{
        background: '#000a2b', color: '#fff'
      }}>
        <div className="mb-5" style={{ height: '45px' }}>
          <div style={{
            display: 'inline-block', verticalAlign: 'bottom', fontSize: '0.795em', float: 'left',
            position: 'relative', left: '30px', top: '20px'
          }}>
            <div style={{ marginRight: '5px', display: 'inline-block', verticalAlign: 'middle' }}><span
              className="lang" keyword="fr">{lang}</span></div><button
                className="btn btn-primary option rounded-circle" type="button" style={{
                  display: 'inline-block'
                  , padding: '1px 5px', paddingTop: '6px', fontSize: '0.985em', boxShadow: 'none',
                  position: 'relative'
                }} data-toggle="dropdown"><i
                  className="material-icons">language</i></button>
            <div className="dropdown-menu drop-lang mt-1" role="menu" style={{ fontSize: '1.26em' }}><a onClick={() => changeLanguageHandler("Fr")}  id="fr"
              className="translate" data-reload><img src="assets/img/france_96px.png"
                style={{ width: '20px', position: 'relative', top: '-3px' }} />&nbsp; <span
                  className="lang" keyword="french" style={{
                    position: 'relative', top: '-2px'
                  }}>{t("french-lang")}</span><br /></a><a onClick={() => changeLanguageHandler("En")}  id="en" className="translate"><img
                    src="assets/img/great_britain_96px.png" style={{
                      width: '20px', position: 'relative',
                      top: '-3px'
                    }} />&nbsp; <span className="lang" keyword="english"
                      style={{ position: 'relative', top: '-2px' }}>{t("english-lang")}</span></a></div>
          </div>
        </div>
        <div className="d-inline-block text-center" style={{ marginTop: '25%' }}><img
          className="img-fluid m-auto d-block" src="assets/img/Logo-Glotelho-Pay-2.png" style={{
            width: '45%'
          }} /></div>
        <div className="w-100" style={{
          color: '#B2BABB', fontSize: '0.865em', position: 'absolute', bottom: '10%'
        }}>
          <p className="w-75 m-auto">{t("Payment_one")}<br /></p>
        </div>
      </div>
      <div className="col col-12 col-md-6 p-0 h-100 of-a" style={{ background: '#fff' }}>
      <div className="w-100 d-block d-md-none" style={{ height: 'auto', position: 'fixed', zIndex: 2000 }}>
          <div className="text-center elipsis pl-2 pr-2 d-block d-md-none" style={{ background: '#C69E44', color: '#fff' }}><span className="ads-txt"><span><strong>No
            1</strong></span><span className="font-weight-light">&nbsp;{t("Number_refill")}</span></span>
          </div>
          <div style={{ height: '70px', background: '#000a2b', color: '#fff', padding: '0 15px' }}>
            <div className="fl-l logo" style={{ position: 'relative' }}><img className="img-fluid" src="assets/img/glo-pay.png" /></div>
            <div className="fl-r mr-2" style={{ display: 'inline-block', verticalAlign: 'bottom', fontSize: '0.795em', position: 'relative', top: '16px' }}>
              <div style={{ marginRight: '5px', display: 'inline-block', verticalAlign: 'middle' }}>
                <span className="lang" keyword="fr">{lang}</span>
              </div>
              <button className="btn btn-primary option rounded-circle" type="button" style={{ display: 'inline-block', padding: '1px 5px', paddingTop: '5px', fontSize: '0.985em', boxShadow: 'none', position: 'relative' }} data-toggle="dropdown" title="Langue">
                <i className="material-icons">language</i>
              </button>
              <div className="dropdown-menu drop-lang" role="menu"  style={{ marginRight: '16px', marginTop: '5px', fontSize: '1.26em' }}>
                <a onClick={() => changeLanguageHandler("Fr")}  id="fr" className="translate" data-reload>
                  <img src="assets/img/france_96px.png" style={{ width: '20px', position: 'relative', top: '-3px' }} />&nbsp;
                  <span className="lang" keyword="french" style={{ position: 'relative', top: '-2px' }}>{t("french-lang")}</span><br />
                </a>
                <a onClick={() => changeLanguageHandler("En")} id="en" className="translate"><img src="assets/img/great_britain_96px-1.png"  style={{ width: '20px', position: 'relative', top: '-3px' }} />&nbsp;
                  <span className="lang" keyword="english" style={{ position: 'relative', top: '-2px' }}>{t("english-lang")}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="space3"></div>
        <div className="col-12 col-md-10 col-lg-9 col-xl-8 mt-form" style={{padding: '25px 30px',background: '#fff'}}>
          <form id="forgot-password" >
            <div>
              <div className="d-inline-block" style={{ verticalAlign: 'top' }}>
                <h1 onClick={()=>navigation("/login")} className="mb-0" style={{ fontWeight: 900 }}><i
                  className="icon ion-arrow-left-c mr-2 cursor" />
                </h1>
              </div>
              <div className="d-inline-block" style={{ verticalAlign: 'top', width: '79%' }}>
                <h1 className="mb-2 title0" style={{ fontWeight: 900, lineHeight: 1 }}>{t("Forgot_password")}
                </h1>
              </div>
              <div id="recover-first" className="display" style={{ display: 'block' }}><span
                style={{ fontWeight: 200 }} >{t("send_reset_code")}</span>
                <div className="mt-4 mb-4">
                  <h6 className="fw-300" style={{ fontSize: '0.9rem' }}>{t("Your_phone_number")}</h6>
                  <input  className="form-control" name="phone" type="number" onChange={(e)=>handleFormChange(e)} maxLength={9} />
                  {error.phoneErr && <span id="login-msg" className="err d-block mt-2">{error.phoneErr}</span>}
                  {!allService.empty(error.errFirst) && <span className="err d-block mt-2"><i className="icon-exclamation mr-2" />{error.errFirst}.</span>}
                </div>
                <button disabled= {load.loadFirst || isDisable.disableFirst} className="btn btn-primary mb-3 app-btn" type="button" style={{width: '100%',textTransform: 'uppercase', boxShadow: 'none', borderRadius: 'initial',padding: '15px'}} onClick = {(e)=>sendDataNumber(e)} > {!load.loadFirst && <i className="icon-key" /> } {load.loadFirst && <i className="fa fa-circle-o-notch fa-spin speed-spin pr" style={{ top: "-1px" }}></i>} &nbsp; {t("SEND_CODE")} </button>
                <span className="mb-5 fw-200 d-block">{t("I_have_my_pass")}  &nbsp;
                  <span onClick={() => navigation("/login")} className="cursor app-color fw-600">{t("I_connect")}</span>
                </span>
              </div>
              <div id="recover-second" className="display"><span style={{ fontWeight: 200 }}>{t("We_have_sent_reset")}</span>
                <div className="mt-4 mb-4">
                  <h6 className="fw-300" style={{ fontSize: '0.9rem' }}>{t("Reset_code")}</h6>
                  <input name="code" onChange={(e)=>handleFormChange(e)} className="form-control" type="number" />
                    {error.codeErr && <span className="err d-block mt-2">{error.codeErr}</span>}
                    {!allService.empty(error.errSecond) && <span className="err d-block mt-2"><i className="icon-exclamation mr-2" />{error.errSecond}.</span>}
                </div>
                <button disabled= {load.loadSecond || isDisable.disableSecond} onClick={(e)=>sendDataNumberCode(e)} className="btn btn-primary mb-3 app-btn" type="button" style={{ width: '100%', textTransform: 'uppercase', boxShadow: 'none', borderRadius: 'initial', padding: '15px'}}>{!load.loadSecond && <i className="icon-key" />} {load.loadSecond && <i className="fa fa-circle-o-notch fa-spin speed-spin pr" style={{ top: "-1px" }}></i>}&nbsp; {t("Change_password")}</button>
                <span className="mb-5 fw-200 d-block">{t("I_didnt_receive")}, &nbsp;<span onClick={()=> saveData2()} className="cursor app-color fw-600">{t("resend_code")}</span></span>
              </div>
              <div id="recover-third" className="display"><span style={{ fontWeight: 200 }}>{t("Enter_confirm")}</span>
                <div className="mt-4 mb-4">
                  <h6 className="fw-300" style={{ fontSize: '0.9rem' }}>{t("New_password")}</h6>
                  <input name="password" value={newUser.password} onChange={(e)=> handleFormChange(e)}
                    className="form-control" type="password" />
                    {!allService.empty(error.passwordErr) && <span className="err">{error.passwordErr}</span>}
                </div>
                <div className="mt-4 mb-4">
                  <h6 className="fw-300" style={{ fontSize: '0.9rem' }}>{t("Confirm")}</h6><input name="confirmpassword" value={newUser.confirmpassword} onChange={(e)=> handleFormChange(e)} 
                    className="form-control" type="password"  />
                     {!allService.empty(error.confirmpasswordErr) && <span className="err">{error.confirmpasswordErr}</span>}
                </div>
                <button disabled= {load.loadThird || isDisable.disableThird} onClick={(e)=>sendDataNumberCodePass(e)} className="btn btn-primary mb-3 app-btn" type="button" style={{width: '100%',textTransform: 'uppercase', boxShadow: 'none', borderRadius: 'initial',padding: '15px'}}>{!load.loadThird && <i className="icon-key" /> } {load.loadThird && <i className="fa fa-circle-o-notch fa-spin speed-spin pr" style={{ top: "-1px" }}></i>}&nbsp; {t("Change_password")}</button>
                {!allService.empty(error.errThird) && <span className="err"><i className="icon-exclamation mr-2" />{error.errThird}.</span>}    
              </div>
            </div>
          </form>
          <span className="fw-100 second-txt-color d-block mt-5 text-center" style={{
            fontSize: '0.865em'
          }}><i className="fa fa-copyright fw-100" />&nbsp;<span>2022</span>&nbsp;<strong>Glotelho
            Pay&nbsp;</strong><span className="lang fw-100 second-txt-color"
              keyword="all-rights-reserved">{t("All_rights_reserved")}</span>.</span>
        </div>
      </div>
      <Toaster toastOptions={{ position: "bottom-center" }} />

      {modalLoader && <div className="modal modal-load text-center display" style={{display:`${modalLoader ? "block" : "none"}`,paddingTop:"120px",backgroundColor:"rgba(255,255,255,0.6)",color:"#091e42"}}>
        <div className="w-100" style={{marginTop:"8em"}}>
          <img src="assets/img/Eclipse-0.3s-800px.gif" alt="loader" className="mb-3" style={{width:"140px"}} />
          <p className="fw-600" style={{fontSize:"0.9em"}}>{t("processing")} ...</p>
        </div>
      </div>}
    </div>
  )
}
